export const LittleLoader = ({className}) => <div className={`lds-ellipsis ${className}`}>
<div></div>
<div></div>
<div></div>
<div></div>
</div>